<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kategori <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="CategoryId" :watch="category">
                <v-select-list v-model="category" :options="categories" label="Name" v-on:input="getTypes(true)" placeholder="Kategori Seçiniz" :disabled="editing || value._create"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Üst Parametre</label>
            <v-validator :errors="errors" parameter="ParentId" :watch="parent">
                <v-select-list v-model="parent" :options="allTypes" label="Name" :loading="loading" placeholder="Üst Parametre Seçiniz (Opsiyonel)" :disabled="!value.CategoryId || editing || value._create"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tip Adı <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input class="form-control" v-model="value.Name" placeholder="Tip Adı Giriniz..." />
            </v-validator>
        </div>
    </div>
</template>

<script>
import IncidentOperationsApi from "@/api/incident-operations";

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            default: () => [],
        },
        editing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            allTypes: [],
            loading:false
        };
    },
    mounted() {
        this.getTypes(false);
    },
    methods: {
        getTypes(bool) {
            if(bool) this.parent = null
            if(this.value.CategoryId){
                this.loading  = true
                IncidentOperationsApi.CaseType.ListWithCategoryId(this.value.CategoryId)
                .then((res) => {
                    if (res.data.Success) {
                        this.allTypes = res.data.Data;
                    }
                    this.loading = false
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false
                });
            }
        },
    },
    computed: {
        category: {
            get() {
                return this.categories.find((c) => c.Id === this.value.CategoryId);
            },
            set(val) {
                this.value.CategoryId = val?.Id || null;
            },
        },
        parent: {
            get() {
                return this.allTypes.find((t) => t.Id === this.value.ParentId);
            },
            set(val) {
                this.value.ParentId = val?.Id || null;
            },
        },
    },
};
</script>
